import React, { useEffect, useRef, useState } from 'react';
import { CLEAR_MESSAGE_EVENT, LOADING_MESSAGE_EVENT, SUCCESS_MESSAGE_EVENT, WARNING_MESSAGE_EVENT } from '../successMessage';

const SuccessMessage = () => {
  const [message, setMessage] = useState(null);
  const timeoutRef = useRef();

  useEffect(() => {
    const showMessage = (type, autoClose = true) => ({ detail }) => {
      window.clearTimeout(timeoutRef.current);
      setMessage({ text: detail, type });
      if (autoClose) timeoutRef.current = window.setTimeout(() => setMessage(null), 3500);
    };

    const showSuccess = showMessage('success');
    const showWarning = showMessage('warning');
    const showLoading = showMessage('loading', false);
    const clearMessage = () => {
      window.clearTimeout(timeoutRef.current);
      setMessage(null);
    };

    window.addEventListener(SUCCESS_MESSAGE_EVENT, showSuccess);
    window.addEventListener(WARNING_MESSAGE_EVENT, showWarning);
    window.addEventListener(LOADING_MESSAGE_EVENT, showLoading);
    window.addEventListener(CLEAR_MESSAGE_EVENT, clearMessage);
    return () => {
      window.removeEventListener(SUCCESS_MESSAGE_EVENT, showSuccess);
      window.removeEventListener(WARNING_MESSAGE_EVENT, showWarning);
      window.removeEventListener(LOADING_MESSAGE_EVENT, showLoading);
      window.removeEventListener(CLEAR_MESSAGE_EVENT, clearMessage);
      window.clearTimeout(timeoutRef.current);
    };
  }, []);

  if (!message) return null;

  return (
    <div className={`pageMessage pageMessage--${message.type}`} role={message.type === 'warning' ? 'alert' : 'status'} aria-live="polite" aria-busy={message.type === 'loading' ? 'true' : undefined}>
      <span className={message.type === 'loading' ? 'pageMessageSpinner' : ''} aria-hidden="true">{message.type === 'warning' ? '!' : message.type === 'loading' ? '' : '✓'}</span>
      <span>{message.text}</span>
    </div>
  );
};

export default SuccessMessage;
